// extracted by mini-css-extract-plugin
export default {"ace-c-qm-feedback-cp-ranking-modal__ranking-panel":"qm-feedback-cp-ranking-modal__ranking-panel---100ceebe"};